module.exports = __webpack_public_path__ + "r-v3/img/zoom_blue.5450d91c.svg";